import { Col, Typography, Layout, Space, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Header160 from "../../header/header";

const { Title, Text } = Typography;

export default function CrudHeader({ title, description, onCreate, extra, permissionInsert }) {
  return (
    <div className="container" style={{ paddingBottom: 20 }}>
      <Layout className="container">
        <div className="header-filter-container d-flex align-items-center justify-content-between">
          <Header160 />
          <Col flex="auto" style={{ textAlign: "center" }}>
            <Space direction="vertical" size={6} align="center">
              <Title
                level={3}
                style={{
                  margin: 0,
                  color: "#042956",
                  fontWeight: 600
                }}
              >
                {title}
              </Title>
              {description && (
                <Text
                  style={{
                    color: "#6b7280",
                    fontSize: 14
                  }}
                >
                  {description}
                </Text>
              )}
              {(onCreate || extra) && (
                <Space>
                  {extra}
                  {onCreate && permissionInsert &&  (
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={onCreate}
                    >
                      Nuevo
                    </Button>
                  )}
                </Space>
              )}
            </Space>
          </Col>
        </div>
      </Layout>
    </div>
  );
}